import { useTranslation } from "react-i18next";
import CustomModal from "../../lib/customModal";
import { SaveWeekTemplate } from "./SaveWeekTemplate";
import { Templates } from "./Templates";

export const CalendarTemplatesSettingsDialog = ({
  open,
  close,
}: {
  open: boolean;
  close: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <CustomModal.Wrapper
        size="large"
        isScrollable={true}
        onClose={close}
        titleText={t("CALENDAR_WEEK_TEMPLATES_MODAL_TITLE")}
        open={open}
      >
        <SaveWeekTemplate />
        <Templates />
      </CustomModal.Wrapper>
    </>
  );
};
